import { customerApi } from "../../utils/apiConfig";

const getAuthHeaders = () => {
  const token = sessionStorage.getItem("token");

  return {
    Authorization: token ? `Bearer ${token}` : "",
    "Content-Type": "application/json",
  };
};

export const createNavlunFreightPrice = (payload) => {
  return customerApi.post("/createNavlunFreightPrice", payload, {
    headers: getAuthHeaders(),
  });
};

export const getNavlunFreightPriceList = (payload) => {
  return customerApi.post("/getNavlunFreightPriceList", payload, {
    headers: getAuthHeaders(),
  });
};

export const getNavlunFreightPriceDetail = (payload) => {
  return customerApi.post("/getNavlunFreightPriceDetail", payload, {
    headers: getAuthHeaders(),
  });
};

export const updateNavlunFreightPrice = (payload) => {
  return customerApi.post("/updateNavlunFreightPrice", payload, {
    headers: getAuthHeaders(),
  });
};

export const deleteNavlunFreightPrice = (payload) => {
  return customerApi.post("/deleteNavlunFreightPrice", payload, {
    headers: getAuthHeaders(),
  });
};
